import { createSelector } from 'reselect';
import { resourcePath } from '@gameday/utils/resource-path';
import { getLanguagePath } from '@gameday/utils/languageHelpers';
import getPOTGVisibility from './getPOTGVisibility';

// selectors
const getGamePk = (state) => state.gumbo?.gamePk;
const getLanguage = (state) => state.config?.language;
const getDeviceInteraction = (state) => state.config?.deviceInteraction;
const getPOTGWinners = (state) => state?.potgWinners?.winners;
const getIsLoadingWinners = (state) => state?.potgWinners?.isLoadingWinners;
const getIsLoadingStories = (state) => state?.potgWinners?.isLoadingStories;
const getBlockLoginActivities = (state) => state?.config?.blockLoginActivities;

const getPlayerOfTheGameState = createSelector(
    [getGamePk, getLanguage, getDeviceInteraction, getPOTGVisibility, getPOTGWinners, getIsLoadingWinners, getIsLoadingStories, getBlockLoginActivities],
    (gamePk, language, deviceInteraction, { showPOTG }, potgWinners, isLoadingWinners, isLoadingStories, blockLoginActivities) => {
        const voteLink = resourcePath.get('playerOfTheGame', {
            gamePk,
            languagePath: getLanguagePath(language)
        });
        const leaderboardLink = resourcePath.get('playerOfTheGameLeaderboard', {
            gamePk,
            languagePath: getLanguagePath(language)
        });

        return {
            showPOTG,
            deviceInteraction,
            voteLink,
            leaderboardLink,
            language,
            winnersConfig: {
                winners: potgWinners,
                isLoadingWinners,
                isLoadingStories
            },
            blockLoginActivities
        };
    }
);

export default getPlayerOfTheGameState;
